export const name = 'dynamicPages' as const
